import { Button, Modal } from 'react-bootstrap';
import Print from '../../print';


/**
 * این کامپوننت برای نمایش مدال پرینت است که در سفارشات  است
 * 
 */
const ModalPrint = ({ showmodal, colseModal, dataPrint }) => {

    const printElement = (elem) => {

        var win = window.open('', 'printwindow');
        win.document.write('<html><head><link rel="stylesheet" type="text/css" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"></head><body>');
        win.document.write(elem.innerHTML);
        win.document.write('</body></html>');
        win.print();
        win.close();
    }

    const handelprint = () => {

        var win = window.open('', 'printwindow');
        const printBody = document.getElementById('bodyPrint').innerHTML;
        win.document.write('<html><head><link rel="stylesheet" type="text/css" href="https://crm.serviq.net/static/css/main.0da758b7.chunk.css"><link rel="stylesheet" type="text/css"></head><body style="margin:50px">');
        win.document.body.innerHTML = printBody;
        win.document.write('</body></html>');
        setTimeout(() => {
            win.print();
        }, 2000);
    }

    // const handelprint = () => {

    //     const body = document.getElementById('bodyPrint').innerHTML;

    //     document.body.innerHTML = body;

    //     window.print();

    //     window.location.reload();
    // }

    return (
        <Modal show={showmodal} onHide={colseModal} className='modalPrint'  >
            <Modal.Header>
                <Modal.Title>پرینت سفارش</Modal.Title>
                <i className="fa fa-times mr-auto" style={{ fontSize: '16px', cursor: 'pointer' }} onClick={colseModal} aria-hidden="true"></i>

            </Modal.Header>
            <Modal.Body id='bodyPrint' >
                {
                    dataPrint.map(item => <Print data={item} />)
                }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handelprint} >پرینت</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalPrint;
